import React from 'react';
import { Link } from 'react-router-dom';

const Subscription: React.FC = () => {
    return (
        <>
            {/* page title */}
            <div className="container py-3">
                <div className="row align-items-center page-title">
                    <div className="col col-sm mb-3 mb-sm-0">
                        <h6 className="mb-0">My Subscription</h6>
                        <p className="text-secondary small">Lets make it open environment to get helped</p>
                    </div>
                    <div className="col-auto ps-0 position-relative mb-3 mb-sm-0">
                        <button className="btn btn-link btn-square" type="button" data-bs-toggle="offcanvas" data-bs-target="#filter" aria-expanded="false">
                            <i className="bi bi-funnel"></i>
                        </button>
                    </div>
                </div>
                <nav aria-label="breadcrumb" className="breadcrumb-theme bg-theme-1-subtle px-2 py-1 mt-0 mt-sm-3 rounded">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item bi"><Link to="/app/dashboard"><i className="bi bi-house-door me-2"></i> DevUIUX</Link></li>
                        <li className="breadcrumb-item bi"><Link to="/app/my-profile"> My Profile</Link></li>
                        <li className="breadcrumb-item bi active" aria-current="page"> My Subscription</li>
                    </ol>
                </nav>
            </div>

            {/* content */}
            <div className="container" id="main-content">
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-lg-5 col-xl-4">

                        <div className="card mb-3 mb-lg-4 overflow-hidden">
                            <div className="coverimg h-100 w-100 position-absolute top-0 start-0 z-index-0 blur-overlay" style={{ backgroundImage: `url(${asset("../../assets/img/background-image/backgorund-image-6.jpg")})` }}>
                                <img src={asset("../../assets/img/background-image/backgorund-image-6.jpg")} alt="" className='d-none' />
                            </div>
                            <div className="card-body position-relative z-index-1">
                                <figure className="avatar avatar-80 rounded-circle mb-3">
                                    <img src={asset("assets/img/logo-512.png")} className="mw-100" alt="" />
                                </figure>
                                <p className="mb-1">You are now premium user</p>
                                <h4 className="mb-0">Business Plan</h4>
                                <br />
                                <br />
                                <p className="mb-1">Annual Plan</p>
                                <h2>$ 250.00</h2>
                                <p className="small opacity-75">Membership valid till 26 June 2027</p>

                                <a href="adminuiux-subscription-plans.html" className="btn btn-theme">Change Plan <i className="bi bi-arrow-right"></i></a>
                            </div>
                        </div>

                    </div>
                    <div className="col-12 col-lg-7 col-xl-8">
                        <div className="card bg-theme-1 text-white mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-12 col-md-auto mb-3 mb-md-0">
                                        <i className="bi bi-gift fs-4 avatar avatar-40 rounded"></i>
                                    </div>
                                    <div className="col-12 col-md mb-3 mb-md-0">
                                        <h6 className="mb-0">Upgrade your plan or renew at 35% OFF limited subscriber offer</h6>
                                        <p className="small opacity-75">Get renew now and you can use current plan and automatically start new subscription on ends.</p>
                                    </div>
                                    <div className="col-12 col-md-auto">
                                        <button className="btn btn-sm btn-light">Upgrade</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 gx-lg-4">
                                    <div className="col-12 col-md-6 col-lg-6 mb-3 mb-md-0">
                                        <h6 className="mb-1">Plan Features</h6>
                                        <p className="text-secondary small mb-3 mb-lg-4">Including features of basic plan</p>
                                        <div className="row mb-2">
                                            <div className="col-auto">
                                                <i className="bi bi-check-circle text-secondary"></i>
                                            </div>
                                            <div className="col-auto ps-0">
                                                Free Shipping
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-auto">
                                                <i className="bi bi-check-circle text-secondary"></i>
                                            </div>
                                            <div className="col-auto ps-0">
                                                Unlimited Send Money
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-auto">
                                                <i className="bi bi-check-circle text-secondary"></i>
                                            </div>
                                            <div className="col-auto ps-0">
                                                Multiple Currencies Support
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-auto">
                                                <i className="bi bi-check-circle text-secondary"></i>
                                            </div>
                                            <div className="col-auto ps-0">
                                                Unlimited Send Money
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-6">
                                        <h6 className="mb-1">Payment Method</h6>
                                        <p className="text-secondary small mb-3 mb-lg-4">1 Credit Card is saved</p>
                                        <div className="row gx-3 mb-2">
                                            <div className="col-auto">
                                                <i className="bi bi-credit-card text-theme-1"></i>
                                            </div>
                                            <div className="col-auto ps-0">
                                                Visa ending ****<b>25480</b>
                                            </div>
                                        </div>
                                        <div className="row mb-4">
                                            <div className="col-auto">
                                                <i className="bi bi-calendar-event text-theme-1"></i>
                                            </div>
                                            <div className="col-auto ps-0">
                                                Next Due <b>22-June-2026</b>
                                            </div>
                                        </div>
                                        <div>
                                            <button className="btn btn-sm btn-link">Change Card</button>
                                            <button className="btn btn-sm btn-link theme-red mx-2">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default Subscription;
